export const MAX_ROWS_COUNT = 6;
export const MAX_COLUMNS_COUNT = 16;
export const HANDHELD_MAX_COLUMNS_COUNT = 14;
export const EMPTY_COLUMNS_COUNT = 4;

export const ROADMAP_CELL_TYPE = {
  TRIPLE: 'triple',
  SMALL: 'small',
  BIG: 'big',
  ODD: 'odd',
  EVEN: 'even',
};

export const EMPTY_CELL = {
  type: ' ',
};
